






























import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { debounce } from 'lodash';
import urlHelper from '@/core/urlHelper.service';
import SearchOverlay from '@/project/search/SearchOverlay.vue';
import { Route } from 'vue-router';
import themeService from '@/project/app/themes/theme.service';
import serverContextService from '@/core/serverContext.service';
import tailwind from '@/styling/tailwind.config';

const minNoOfCharacters = 2;
const debounceTime = 300;
@Component({
    components: { SearchOverlay }
})
export default class SearchCtrl extends Vue {
    private term = '';
    private debounceSetTerm = debounce(this.setTerm, debounceTime);
    private show = this.shouldShowOverlay(this.term);
    private typing = false;

    @Prop({ type: HTMLElement })
    anchorElement!: HTMLElement;

    @Prop({ type: Boolean, default: false })
    noBorder!: boolean;

    @Watch('$route')
    private onRouteChange(route: Route, oldRoute: Route) {
        if (!this.show) {
            const term = urlHelper.getTerm();
            if (!term) {
                return;
            } else {
                this.onTermChanged(term);
            }
        }

        if (!urlHelper.getTerm()) {
            // We came to page without term - reset / close
            this.setTerm('', false);
        } else {
            // Term updated - for instance from translation (alternative) search
            this.setSyncedTerm(urlHelper.getTerm()!);
        }
    }

    @Watch('term')
    private onTermChanged(term: string) {
        this.typing = true;

        this.debounceSetTerm(term);
    }

    private setTerm(term: string, goBack: boolean = true) {
        this.setSyncedTerm(term);
        const oldShow = this.show;
        this.show = this.shouldShowOverlay(term);

        if (this.show) {
            const justShown = this.show && !oldShow;
            urlHelper.setTerm(term, justShown);
            if (!justShown) {
                urlHelper.clearFacets();
            }
        }

        this.typing = false;
    }

    private reset() {
        this.setTerm('');
        urlHelper.setTerm('');
    }

    private shouldShowOverlay(term: string): boolean {
        return term?.length >= minNoOfCharacters;
    }

    private setSyncedTerm(term: string = '') {
        this.term = term;
        this.$refs.inputElem.value = term;
    }

    private lowlevelInputHandler(term: string) {
        if (term.length > 0 && term.trim().length === 0) {
            this.$refs.inputElem.value = '';
        } else {
            this.term = term;
        }
    }

    $refs!: Vue['$refs'] & {
        inputElem: HTMLInputElement
    }

    private mounted() {
        this.setSyncedTerm(urlHelper.getTerm());
    }

    private get searchInputIconColor(): string {
        return themeService.isInWhiteTheme ? 'white' : this.isOprema ? 'black' : (tailwind.theme.colors.blue['500']);
    }

    get isOprema() {
        return serverContextService?.isOprema;
    }

    private get searchInputStyle(): Partial<CSSStyleDeclaration> {
        const isInWhiteTheme = themeService.isInWhiteTheme;

        return {
            ...(isInWhiteTheme && { color: '#fff' }),
            ...(isInWhiteTheme && { backgroundColor: 'transparent' }),
            ...(isInWhiteTheme && { borderColor: '#fff' })
        };
    }
}

